// 

import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

@Component({
  selector: "app-widget-metric-dialog",
  templateUrl: "./widget-metric-dialog.component.html",
  styleUrls: ["./widget-metric-dialog.component.scss"],
})
export class WidgetMetricDialogComponent implements OnInit {
  metricForm = new FormGroup({
    metrics: new FormControl(""),
  });

  metricsList: any[] = [];
  metricCtrl = new FormControl();
  filteredMetrics!: Observable<any[]>;
  selectedMetrics: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<WidgetMetricDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.metricsList = this.data.metricsList ?? [];

    const selectedIds = this.data.selectedMetrics ?? [];
    this.selectedMetrics = this.metricsList.filter((item) =>
      selectedIds.includes(item.id)
    );

    this.metricForm.patchValue({ metrics: selectedIds });

    this.filteredMetrics = this.metricCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value ?? ""))
    );
  }

  closeDialog() {
    this.dialogRef.close();
  }

  addMetrics() {
    const selectedMetricIds = this.selectedMetrics.map((metric) => metric.id);
    this.dialogRef.close(selectedMetricIds);
  }

  toggleMetric(metric: any): void {
    if (this.isSelected(metric)) {
      this.remove(metric);
    } else {
      this.selectedMetrics.push(metric);
    }
    this.refreshFilter();
  }

  remove(metric: any): void {
    this.selectedMetrics = this.selectedMetrics.filter(
      (m) => m.id !== metric.id
    );
  }

  isSelected(metric: any): boolean {
    return this.selectedMetrics.some((m) => m.id === metric.id);
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.metricsList.filter(
      (metric) =>
        metric.display_name.toLowerCase().includes(filterValue) &&
        !this.isSelected(metric)
    );
  }

  private refreshFilter(): void {
    const currentValue = this.metricCtrl.value ?? "";
    this.filteredMetrics = this.metricCtrl.valueChanges.pipe(
      startWith(currentValue),
      map((value) => this._filter(value ?? ""))
    );
  }
}
